import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { USER } from 'src/app/core/user.service';
import { LogMode } from 'src/app/shared/flight-log-api/flight-logs/flight-log-client.model';
import { CrewMemberDto } from 'src/app/shared/flight-log-api/shared/shared-client.model';
import { getValueChanges } from 'src/util/angular/ng-forms-helpers';
import { combineValidtionErrorsChanges } from 'src/util/angular/ng-forms-validation';
import { FlightLogFeatures, UserViewModel } from 'src/view-models/user-view-model';
import { FlightLogFormHelper } from '../../flight-log-form-helper';

@Component({
  selector: 'fl-flight-leg-crew-member',
  templateUrl: './flight-leg-crew-member.component.html',
  styleUrls: ['./flight-leg-crew-member.component.scss'],
})
export class FlightLegCrewMemberComponent implements OnInit, OnChanges {
  @Input()
  public formHelper: FlightLogFormHelper;

  @Input()
  public crewMember: CrewMemberDto;

  @Input()
  public crewMemberAboard: FormGroup;

  @Input()
  public enableNvg = false;

  @Output()
  public onboard = new EventEmitter();

  @Output()
  public disboard = new EventEmitter();

  public aboardToggle = false;
  public isPilot = false;
  public isCrewMemberNvgSelected$: Observable<boolean>;
  public crewMemberErrors$: Observable<string[]>;

  get isSimple() {
    return this.formHelper.flight.mode === LogMode.Simple;
  }

  get displayName() {
    const role = this.crewMember.role;
    const roleDisplay =
      role === 'PilotInCommand'
        ? 'PIC'
        : role === 'CoPilot'
        ? 'Co-Pilot'
        : role === 'Clinical'
        ? 'Medic'
        : null;

    const nameDisplay = `${this.crewMember.firstName} ${this.crewMember.lastName}`;
    return roleDisplay != null ? `${nameDisplay} (${roleDisplay})` : nameDisplay;
  }

  get isAboard() {
    return this.crewMemberAboard !== null;
  }

  public emitAboardChange(event: any) {
    const aboard = event.target.checked as boolean | undefined;
    if (aboard != null && aboard) {
      this.onboard.emit();
    } else {
      this.disboard.emit();
    }
  }

  public crewMemberNvgChanged(event: any) {
    if (!this.isPilot) {
      const nvgSelected = event.target.checked as boolean | undefined;
      if (nvgSelected != null && nvgSelected) {
        // Defaul value to 1 as per requirement
        const hnvgoCtrl = this.crewMemberAboard.get('hnvgo') as FormControl;
        hnvgoCtrl.setValue(1);
      } else {
        const hnvgoCtrl = this.crewMemberAboard.get('hnvgo') as FormControl;
        hnvgoCtrl.setValue(null);
      }
    }
  }

  constructor(@Inject(USER) private _user: UserViewModel) {}

  public ngOnInit() {
    const role = this.crewMember.role;
    this.isPilot = role === 'PilotInCommand' || role === 'CoPilot';

    if (this.crewMemberAboard != null) {
      const nvgCtrl = this.crewMemberAboard.get('isNvg') as FormControl;
      this.isCrewMemberNvgSelected$ = getValueChanges<boolean>(nvgCtrl);

      this.crewMemberErrors$ = combineValidtionErrorsChanges([
        this.crewMemberAboard,
        // tslint:disable-next-line: no-non-null-assertion
        this.crewMemberAboard.get('hnvgo')!,
      ]);
    }
  }

  public ngOnChanges() {
    this.aboardToggle = this.isAboard;
  }

  public get features(): FlightLogFeatures {
    return this._user.flightLogFeatures;
  }
}
